<template>
  <b-col>
    <div ref="profile__card" class="profile__card">
      <BaseUserProfile
        ref="component__baseUserProfile"
        :user-name="`${user.firstname} ${user.lastname}`"
        :picture="user.profile_picture"
        :size="100"
      ></BaseUserProfile>
      <div ref="container__user-info" class="text-center">
        <div
          ref="profile__name"
          class="profile__name font-weight-bold mt-u8 text-capitalize text__profile-name"
        >
          {{ user.firstname }} {{ user.lastname }}
        </div>
        <div ref="profile__current-occupation" class="profile__current-occupation text-dark">
          <span class="text-capitalize"> {{ currentOccupation }}</span>
          <span v-if="user && user.company"> at {{ user.company }}</span>
        </div>
        <BaseHideContentWrapper
          ref="component__BaseHideContentWrapper"
          :active="isDescriptionHidden"
        >
          <div ref="profile__description" class="profile__description mt-2">
            {{ user.description }}
          </div>
        </BaseHideContentWrapper>
      </div>

      <div v-if="editable" class="mt-2">
        <a ref="button__edit-description" class="button__edit-description" @click="goToEditProfile">
          <b-img
            ref="icon__edit-description"
            class="icon__edit-description"
            :src="require(`@/assets/user-profile-icons/icon-edit.svg`)"
          />
          Edit
        </a>
      </div>
    </div>
  </b-col>
</template>

<script>
import * as PROFILE_OPTIONS from '@/assets/user-profile-template.json';
// import BaseAvatar from '@/components/base-components/BaseAvatar.vue';
import BaseHideContentWrapper from '@/components/base-components/BaseHideContentWrapper.vue';
import BaseUserProfile from '@/components/base-components/BaseUserProfile.vue';

export default {
  components: {
    // BaseAvatar,
    BaseHideContentWrapper,
    BaseUserProfile
  },

  props: {
    editable: {
      type: Boolean,
      default: false
    },

    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isDescriptionHidden: true
    };
  },
  computed: {
    currentOccupation() {
      return this.user?.current_occupation
        ? this.currentOccupations[this.user.current_occupation]
          ? this.currentOccupations[this.user.current_occupation]
          : this.user.current_occupation.split('|')[1]
        : '-';
    },
    currentOccupations() {
      const results = {};
      PROFILE_OPTIONS.aboutYouFields.fields.currentOccupation.options.forEach((option) => {
        results[option.value] = option.name;
      });
      return results;
    }
  },
  methods: {
    goToEditProfile() {
      return this.$router.push({ name: 'profile/edit' });
    }
  }
};
</script>

<style scoped>
.profile__card {
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  background-color: #ffffff;
  padding: 25px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.profile__name {
  font-size: 28px;
  line-height: 30px;
  text-transform: capitalize;
}

.profile__current-occupation {
  font-size: 15.2px;
  margin: 5px 0;
}

.button__edit-description {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #3c44b1 !important;
  cursor: pointer;
}

.icon__edit-description {
  width: 20px;
  height: 20px;
}
</style>
